import {
  AttendantRead,
  useAttendantsCreateMutation,
  useAttendantsDestroyMutation,
  useAttendantsPartialUpdateMutation,
  useAttendantsSkillsCreateMutation,
  useAttendantsSkillsDestroyMutation,
  useAttendantsSkillsPartialUpdateMutation,
} from 'src/common/external/bambi-api/bambiApi';

export function useAttendantProfileRepository() {
  const [createAttendant] = useAttendantsCreateMutation();
  const [updateAttendant] = useAttendantsPartialUpdateMutation();
  const [destroyAttendant] = useAttendantsDestroyMutation();
  const [createAttendantSkills] = useAttendantsSkillsCreateMutation();
  const [updateAttendantSkills] = useAttendantsSkillsPartialUpdateMutation();
  const [destroyAttendantSkills] = useAttendantsSkillsDestroyMutation();

  return {
    createAttendant: async (attendant: AttendantRead) => {
      const attendantWithNoSkills = await createAttendant({
        attendant,
      }).unwrap();
      const attendantSkills = await createAttendantSkills({
        attendantSkills: {
          ...attendant.skills,
          attendant: attendantWithNoSkills.id,
        },
      }).unwrap();
      return {
        ...attendantWithNoSkills,
        skills: attendantSkills,
      };
    },
    updateAttendant: async (patchedAttendant: AttendantRead) => {
      const attendantWithOutdatedSkills = await updateAttendant({
        id: patchedAttendant.id,
        patchedAttendant,
      }).unwrap();
      const updatedAttendantSkills = await updateAttendantSkills({
        id: attendantWithOutdatedSkills.skills.id || '',
        patchedAttendantSkills: {
          ...patchedAttendant.skills,
        },
      }).unwrap();
      return {
        ...attendantWithOutdatedSkills,
        skills: updatedAttendantSkills,
      };
    },
    destroyAttendant: async (attendant: AttendantRead) => {
      const destroyedAttendantSkills = await destroyAttendantSkills({
        id: attendant.skills.id || '',
      }).unwrap();
      const destroyedAttendant = destroyAttendant({
        id: attendant.id,
      }).unwrap();

      return {
        ...destroyedAttendant,
        skills: destroyedAttendantSkills,
      };
    },
  };
}
